<template>
  <div class="navigatorMachineAccountsDashboard">
  <NavbarComponent :loadingStatus="loading">Navigator Machine Accounts</NavbarComponent>
  <section class="navgiatormachineaccountssection">
  <div v-if="!loading" class="container is-fluid">
  {{message}}
  <p>Note: Navigator Machine Account Name is only used to assign the correct account to Navigator AU Tools Users</p>

       <b-button
                            label="Add New"
                            type="is-primary"
							@click="addNewModal=true"/>
<br>
  <div class="datatable" v-if="tableData"><b-table :data="tableData" :options="options">

        <b-table-column field="id" label="Name" width="50px"  v-slot="props">
            {{ props.row.id }}
        </b-table-column>
               <b-table-column field="navigator_machine_account_name" label="Navigator Machine Account Name"  v-slot="props">
            {{ props.row.navigator_machine_account_name }}
        </b-table-column>
        <b-table-column field="client_id" label="Client_Id"  v-slot="props">
            {{ props.row.client_id }}
        </b-table-column>
               <b-table-column field="delete" label="Delete"  v-slot="props">
            <b-button
                            label="Delete"
                            type="is-dark"
							@click="deleteMachineAccountButton(props.row.id, props.row.navigator_machine_account_name, props.row.client_id)"/>
        </b-table-column>

  </b-table></div>
       
 </div>
 </section>
 
    
  <b-modal v-model="addNewModal" :active.sync="addNewModal"  :autofocus="true">
                <div class="modal-card">

                    <section class="modal-card-body">
                        <b-field label="Navigator Machine Account Name">
                            <b-input type="text"
                            id="password_input"
                            v-model="new_navigator_machine_account_name"
                            >
                            </b-input>
                            </b-field>
                                         <b-field label="Client ID">
                            <b-input type="text"
                            v-model="new_client_id"
                             >
                            </b-input>
                            </b-field>
                            <b-field label="Client Secret ">
                            <b-input type="password"
                            v-model="new_client_secret"
                                password-reveal>
                            </b-input>
                            </b-field>

                            
                 
                        </section>
                    
                        <b-button
                            label="Add"
                            type="is-warning"
							@click="addMachineAccount"/>


                   <b-button
                            label="Close"
                            type="is-primary"
							@click="addNewModal=false"/>
                </div>

        </b-modal>


        
  <b-modal v-model="deleteModalActive" :active.sync="deleteModalActive"  :autofocus="true">
                <div class="modal-card">

                    <section class="modal-card-body">
                      Deleting {{this.deleteMachineAccountName}} with Client Id {{this.deleteMachineAccountClientId}}
                      <br>
                      Confirm you want to delete machine account?
                        </section>
                    
                        <b-button
                            label="Yes, Delete."
                            type="is-warning"
							@click="deleteMachineAccount()"/>
                

                  <b-button
                            label="No, Cancel."
                            type="is-primary"
							@click="deleteModalActive=false"/>
                </div>

        </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import NavbarComponent from '@/components/NavbarComponent.vue'



export default {
  name: 'NavigatorScriptDownloader',
  props: {
  },
  components: {NavbarComponent},
  data() {return {
    loading: false,
    message: '',
    deleteMachineAccountId: '',
    deleteMachineAccountName:'',
    deleteMachineAccountClientId:'',
    addNewModal: false,
    deleteModalActive: false,
    new_navigator_machine_account_name: '',
    new_client_id: '',
    new_client_secret:'',
    scripts: [],
    scriptDownloadIdList: [],
    tableData:[],
    columns: ['id', 'navigator_machine_account_name', 'client_id'],
        options: {  
      sortIcon: { //set sort icons
        base : 'fa',
        is: 'fa-sort',
        up:  'fa-sort-down',
        down:   'fa-sort-up'
      }
},
    }
  },
  methods:{
    async getMachineAccounts(){


        this.loading=true;
            //Navigator devices API url
            const url = this.$store.getters.apiurl + "navigator_machine_accounts"

            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.tableData = response.data.data
				console.log(this.tableData)
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
    },

    deleteMachineAccountButton(id,name,client_id)
    {
      console.log("deleting")
    this.deleteMachineAccountId = id
    this.deleteMachineAccountName = name
    this.deleteMachineAccountClientId= client_id
    this.deleteModalActive=true
    },
    async deleteMachineAccount(){
              this.loading=true;
            //Navigator devices API url
            const url = this.$store.getters.apiurl + "navigator_machine_account/" + this.deleteMachineAccountId

            this.$axios({ method: 'delete',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded','Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                 this.getMachineAccounts();
				 this.message = "";
                 this.loading=false;
                 this.deleteModalActive=false;
            }).catch(error => { 
                 this.loading=false;
                 this.deleteModalActive=false;
                 this.message="Error. Something went wrong. Could not delete machine account"
            console.log(error)             
            });  
    },

    addMachineAccount(){
        this.loading=true;
       this.$axios({
                    method: 'POST',
                    url: this.$store.getters.apiurl + "navigator_machine_account",
                    data: {
                        'navigator_machine_account_name':this.new_navigator_machine_account_name,
                        'client_id': this.new_client_id,
                        'client_secret' : this.new_client_secret,
        
                    },
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': this.$store.getters.oidcIdToken
                    }
                })
                .then((response) => {
                  this.getMachineAccounts()
                    console.log(response)
                           this.addNewModal=false;
                         this.new_navigator_machine_account_name= ''
                        this.new_client_id= ''
                        this.new_client_secret=''
					this.message = "";
                     this.loading = false;
              

                }).catch((error) => {
                  this.addNewModal=false;
                  this.loading=false;
                  this.message = "Error. Something went wrong. Could not add new machine account. Please make sure name is unique."
                    console.log(error);
                    //remove all the stored data if any.

                   
                });
	

    },
  },
  mounted() {
  this.getMachineAccounts();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-card, .modal-content {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: auto;
}
.ruledatabasesection{
margin-left:-30px;
margin-right:-30px;
padding-left:-30px;
padding-right:-30px;

}




</style>
